import FJMediaSettingContainer from '../FJMediaSetting/FJMediaSettingContainer';
import FJVoiceSettingContainer from '../FJVoiceSetting/FJVoiceSettingContainer';
import FJSubtitleSettingContainer from '../FJSubtitleSetting/FJSubtitleSettingContainer';
import styles from './FJVideoSettings.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller';
import FJFreeTimesSpan from '../FJFreeTimesSpan/FJFreeTimesSpan';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton';
import FJUtil from '../../../util/FJUtil';
import FJConstant from '../../../constants/FJConstant';
import cionNew from '../../../assets/base64/cion-new.js';
import FJEvent from '../../../store/FJEvent.js';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant.js';
import FJTextToVideoFooter from '../FJTextToVideoFooter/FJTextToVideoFooter';
import FJAppConstant from '../../../constants/FJAppConstant.js';
import FJTextToVideoStore from '../../../store/FJTextToVideoStore.js';
const FJVideoSettings = props => {
    const {
        onGenerate,
        freeTimes,
        isShowImageSetting = true,
        useCreditInfo,
        creditNumber,
        mediaSource,
        selectTab,
        defaultFreeNumCreation,
    } = props;
    const { useCredits, useFreeTimes: isFree } = useCreditInfo;

    const useCredit = Math.floor((isFree ? 0 : useCredits) * 10) / 10;
    const showGetMoreCredits =
        creditNumber === 0 &&
        (selectTab === FJAppConstant.TEXT_TO_FULL_VIDEO || selectTab === FJAppConstant.BLOG_URL_TO_VIDEO) &&
        mediaSource === FJConstant.AI_GENERATED &&
        freeTimes > 0;
    const isShowCreditIcon = creditNumber === 0 && freeTimes > 0;
    const _onScroll = () => {
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_ALL_DROP_DOWN);
    };
    const isLogin = FJUtil.isLogin();
    return (
        <>
            <FJVerticalScroller className={styles.container} onScroll={_onScroll}>
                {isShowImageSetting && <FJMediaSettingContainer isShowCreditIcon={isShowCreditIcon} />}
                <FJVoiceSettingContainer />
                <FJSubtitleSettingContainer />
            </FJVerticalScroller>
            <FJTextToVideoFooter className={styles.footer}>
                <div
                    className={styles.footer_content}
                    style={{
                        justifyContent: !isFree || showGetMoreCredits ? 'center' : 'space-between',
                    }}
                >
                    {showGetMoreCredits ? (
                        <FJButton
                            className={styles.get_credits_btn}
                            text={FJLocalStore._('get-more-credits')}
                            onClick={() => {
                                FJUtil.getCredits(FJTextToVideoStore.getAppType());
                            }}
                            icon={<img src={cionNew} className={styles.cion} />}
                            type={FJButtonType.CREDIT}
                        />
                    ) : (
                        <>
                            {!isLogin && defaultFreeNumCreation > 0 && (
                                <FJFreeTimesSpan desc={FJLocalStore._('free-try')} />
                            )}
                            {isFree && isLogin && <FJFreeTimesSpan times={freeTimes} />}
                            <FJGenerateButton
                                className={styles.generate_btn}
                                text={FJLocalStore._('generate')}
                                onClick={onGenerate}
                                isFree={isFree}
                                hideFreeCreation={true}
                                useCredit={useCredit}
                                isShowUsageDetail={true}
                                usageDetailOffsetLeft={-23}
                                usageDetailOffsetTop={-35}
                                defaultFreeNumCreation={defaultFreeNumCreation}
                            />
                        </>
                    )}
                </div>
            </FJTextToVideoFooter>
        </>
    );
};

FJVideoSettings.propTypes = {
    onGenerate: PropTypes.func,
    freeTimes: PropTypes.number,
    isShowImageSetting: PropTypes.bool,
    useCreditInfo: PropTypes.object,
    creditNumber: PropTypes.number,
    mediaSource: PropTypes.string,
    selectTab: PropTypes.string,
    defaultFreeNumCreation: PropTypes.number,
};

export default FJVideoSettings;
